var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.42871,
    cy: 6,
    r: 6,
    fill: "#FF3B30"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.53226 4.60355C8.72753 4.40829 8.72753 4.09171 8.53226 3.89645C8.337 3.70118 8.02042 3.70118 7.82516 3.89645L6.42871 5.29289L5.03226 3.89645C4.837 3.70118 4.52042 3.70118 4.32516 3.89645C4.1299 4.09171 4.1299 4.40829 4.32516 4.60355L5.7216 6L4.32516 7.39645C4.1299 7.59171 4.1299 7.90829 4.32516 8.10355C4.52042 8.29882 4.837 8.29882 5.03226 8.10355L6.42871 6.70711L7.82516 8.10355C8.02042 8.29882 8.337 8.29882 8.53226 8.10355C8.72753 7.90829 8.72753 7.59171 8.53226 7.39645L7.13582 6L8.53226 4.60355Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabled);
export default __webpack_public_path__ + "static/media/disabled.56254f1468fb6fce69d1350f0d3101cd.svg";
export { ForwardRef as ReactComponent };